"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiChargeCancelDto = void 0;
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
const billing_core_charge_cancel_reason_enum_1 = require("../../../../billing-core/billing-core-charge/types/enums/billing-core-charge-cancel-reason.enum");
/**
 * Запрос на отмену начисления
 */
class BillingApiChargeCancelDto {}
__decorate([(0, swagger_1.ApiProperty)({
  description: `Использовать возвраты или нет. Если не задано или false,
    то при наличие оплаченных начислений будет 405 http-код`,
  enum: billing_core_charge_cancel_reason_enum_1.BillingCoreChargeCancelReasonEnum
}), __metadata("design:type", Object)], BillingApiChargeCancelDto.prototype, "refund", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма возврата (так как возврат может быть частичным)",
  type: String,
  nullable: true,
  required: false,
  format: "decimal",
  pattern: "^d{1,}(.d{1,6})?$",
  example: "100.00"
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDecimal)({
  decimal_digits: "1,"
}), __metadata("design:type", Object)], BillingApiChargeCancelDto.prototype, "refundAmount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Процент возврата (так как возврат может быть частичным)",
  type: String,
  nullable: true,
  required: false,
  format: "decimal",
  pattern: "^d{1,}(.d{1,6})?$",
  example: "100.00"
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDecimal)({
  decimal_digits: "1,"
}), __metadata("design:type", Object)], BillingApiChargeCancelDto.prototype, "refundPercent", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Причина отмены из классификатора",
  enum: billing_core_charge_cancel_reason_enum_1.BillingCoreChargeCancelReasonEnum
}), (0, class_validator_1.IsEnum)(billing_core_charge_cancel_reason_enum_1.BillingCoreChargeCancelReasonEnum), __metadata("design:type", String)], BillingApiChargeCancelDto.prototype, "cancelReason", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сообщение уточнющее информацию об отмене."
}), (0, class_validator_1.IsString)(), (0, class_validator_1.Length)(1), __metadata("design:type", String)], BillingApiChargeCancelDto.prototype, "cancelMessage", void 0);
exports.BillingApiChargeCancelDto = BillingApiChargeCancelDto;
